/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MainRouteImport } from './routes/_main'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as MainRequestExamRouteImport } from './routes/_main/request-exam'
import { Route as MainProfileRouteImport } from './routes/_main/profile'
import { Route as MainDashboardRouteImport } from './routes/_main/dashboard'
import { Route as MainAdminRouteImport } from './routes/_main/admin'
import { Route as AuthVerifyEmailRouteImport } from './routes/_auth/verify-email'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthRegisterRouteImport } from './routes/_auth/register'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as MainGroupsGidRouteImport } from './routes/_main/groups/$gid'
import { Route as MainAdminGroupsRouteImport } from './routes/_main/admin_.groups'
import { Route as MainExamsSlugIndexRouteImport } from './routes/_main/exams/$slug/index'
import { Route as MainExamsSlugSubmissionsRouteImport } from './routes/_main/exams/$slug/submissions'
import { Route as MainExamsSlugQuestionsRouteImport } from './routes/_main/exams/$slug/questions'
import { Route as MainExamsSlugHistoryRouteImport } from './routes/_main/exams/$slug/history'
import { Route as MainExamsSlugAnalyticsRouteImport } from './routes/_main/exams/$slug/analytics'
import { Route as MainExamsSlugTestNewRouteImport } from './routes/_main/exams/$slug/test/new'
import { Route as MainExamsSlugAdminReportsRouteImport } from './routes/_main/exams/$slug/admin/reports'
import { Route as MainGroupsGidExamsSlugIndexRouteImport } from './routes/_main/groups/$gid/exams/$slug/index'
import { Route as MainExamsSlugTestIdIndexRouteImport } from './routes/_main/exams/$slug/test/$id/index'
import { Route as MainExamsSlugAdminQuestionsIndexRouteImport } from './routes/_main/exams/$slug/admin/questions/index'
import { Route as MainGroupsGidExamsSlugQuestionsRouteImport } from './routes/_main/groups/$gid/exams/$slug/questions'
import { Route as MainGroupsGidExamsSlugHistoryRouteImport } from './routes/_main/groups/$gid/exams/$slug/history'
import { Route as MainGroupsGidExamsSlugAnalyticsRouteImport } from './routes/_main/groups/$gid/exams/$slug/analytics'
import { Route as MainExamsSlugTestIdResultRouteImport } from './routes/_main/exams/$slug/test/$id/result'
import { Route as MainExamsSlugAdminQuestionsReviewRouteImport } from './routes/_main/exams/$slug/admin/questions/review'
import { Route as MainExamsSlugAdminQuestionsNewRouteImport } from './routes/_main/exams/$slug/admin/questions/new'
import { Route as MainExamsSlugAdminQuestionsGenerateRouteImport } from './routes/_main/exams/$slug/admin/questions/generate'
import { Route as MainExamsSlugAdminQuestionsBulkRouteImport } from './routes/_main/exams/$slug/admin/questions/bulk'
import { Route as MainGroupsGidExamsSlugTestNewRouteImport } from './routes/_main/groups/$gid/exams/$slug/test/new'
import { Route as MainExamsSlugAdminQuestionsIdEditRouteImport } from './routes/_main/exams/$slug/admin/questions/$id/edit'
import { Route as MainGroupsGidExamsSlugTestIdIndexRouteImport } from './routes/_main/groups/$gid/exams/$slug/test/$id/index'
import { Route as MainGroupsGidExamsSlugTestIdResultRouteImport } from './routes/_main/groups/$gid/exams/$slug/test/$id/result'

const MainRoute = MainRouteImport.update({
  id: '/_main',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const MainRequestExamRoute = MainRequestExamRouteImport.update({
  id: '/request-exam',
  path: '/request-exam',
  getParentRoute: () => MainRoute,
} as any)
const MainProfileRoute = MainProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => MainRoute,
} as any)
const MainDashboardRoute = MainDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => MainRoute,
} as any)
const MainAdminRoute = MainAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => MainRoute,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const MainGroupsGidRoute = MainGroupsGidRouteImport.update({
  id: '/groups/$gid',
  path: '/groups/$gid',
  getParentRoute: () => MainRoute,
} as any)
const MainAdminGroupsRoute = MainAdminGroupsRouteImport.update({
  id: '/admin_/groups',
  path: '/admin/groups',
  getParentRoute: () => MainRoute,
} as any)
const MainExamsSlugIndexRoute = MainExamsSlugIndexRouteImport.update({
  id: '/exams/$slug/',
  path: '/exams/$slug/',
  getParentRoute: () => MainRoute,
} as any)
const MainExamsSlugSubmissionsRoute =
  MainExamsSlugSubmissionsRouteImport.update({
    id: '/exams/$slug/submissions',
    path: '/exams/$slug/submissions',
    getParentRoute: () => MainRoute,
  } as any)
const MainExamsSlugQuestionsRoute = MainExamsSlugQuestionsRouteImport.update({
  id: '/exams/$slug/questions',
  path: '/exams/$slug/questions',
  getParentRoute: () => MainRoute,
} as any)
const MainExamsSlugHistoryRoute = MainExamsSlugHistoryRouteImport.update({
  id: '/exams/$slug/history',
  path: '/exams/$slug/history',
  getParentRoute: () => MainRoute,
} as any)
const MainExamsSlugAnalyticsRoute = MainExamsSlugAnalyticsRouteImport.update({
  id: '/exams/$slug/analytics',
  path: '/exams/$slug/analytics',
  getParentRoute: () => MainRoute,
} as any)
const MainExamsSlugTestNewRoute = MainExamsSlugTestNewRouteImport.update({
  id: '/exams/$slug/test/new',
  path: '/exams/$slug/test/new',
  getParentRoute: () => MainRoute,
} as any)
const MainExamsSlugAdminReportsRoute =
  MainExamsSlugAdminReportsRouteImport.update({
    id: '/exams/$slug/admin/reports',
    path: '/exams/$slug/admin/reports',
    getParentRoute: () => MainRoute,
  } as any)
const MainGroupsGidExamsSlugIndexRoute =
  MainGroupsGidExamsSlugIndexRouteImport.update({
    id: '/exams/$slug/',
    path: '/exams/$slug/',
    getParentRoute: () => MainGroupsGidRoute,
  } as any)
const MainExamsSlugTestIdIndexRoute =
  MainExamsSlugTestIdIndexRouteImport.update({
    id: '/exams/$slug/test/$id/',
    path: '/exams/$slug/test/$id/',
    getParentRoute: () => MainRoute,
  } as any)
const MainExamsSlugAdminQuestionsIndexRoute =
  MainExamsSlugAdminQuestionsIndexRouteImport.update({
    id: '/exams/$slug/admin/questions/',
    path: '/exams/$slug/admin/questions/',
    getParentRoute: () => MainRoute,
  } as any)
const MainGroupsGidExamsSlugQuestionsRoute =
  MainGroupsGidExamsSlugQuestionsRouteImport.update({
    id: '/exams/$slug/questions',
    path: '/exams/$slug/questions',
    getParentRoute: () => MainGroupsGidRoute,
  } as any)
const MainGroupsGidExamsSlugHistoryRoute =
  MainGroupsGidExamsSlugHistoryRouteImport.update({
    id: '/exams/$slug/history',
    path: '/exams/$slug/history',
    getParentRoute: () => MainGroupsGidRoute,
  } as any)
const MainGroupsGidExamsSlugAnalyticsRoute =
  MainGroupsGidExamsSlugAnalyticsRouteImport.update({
    id: '/exams/$slug/analytics',
    path: '/exams/$slug/analytics',
    getParentRoute: () => MainGroupsGidRoute,
  } as any)
const MainExamsSlugTestIdResultRoute =
  MainExamsSlugTestIdResultRouteImport.update({
    id: '/exams/$slug/test/$id/result',
    path: '/exams/$slug/test/$id/result',
    getParentRoute: () => MainRoute,
  } as any)
const MainExamsSlugAdminQuestionsReviewRoute =
  MainExamsSlugAdminQuestionsReviewRouteImport.update({
    id: '/exams/$slug/admin/questions/review',
    path: '/exams/$slug/admin/questions/review',
    getParentRoute: () => MainRoute,
  } as any)
const MainExamsSlugAdminQuestionsNewRoute =
  MainExamsSlugAdminQuestionsNewRouteImport.update({
    id: '/exams/$slug/admin/questions/new',
    path: '/exams/$slug/admin/questions/new',
    getParentRoute: () => MainRoute,
  } as any)
const MainExamsSlugAdminQuestionsGenerateRoute =
  MainExamsSlugAdminQuestionsGenerateRouteImport.update({
    id: '/exams/$slug/admin/questions/generate',
    path: '/exams/$slug/admin/questions/generate',
    getParentRoute: () => MainRoute,
  } as any)
const MainExamsSlugAdminQuestionsBulkRoute =
  MainExamsSlugAdminQuestionsBulkRouteImport.update({
    id: '/exams/$slug/admin/questions/bulk',
    path: '/exams/$slug/admin/questions/bulk',
    getParentRoute: () => MainRoute,
  } as any)
const MainGroupsGidExamsSlugTestNewRoute =
  MainGroupsGidExamsSlugTestNewRouteImport.update({
    id: '/exams/$slug/test/new',
    path: '/exams/$slug/test/new',
    getParentRoute: () => MainGroupsGidRoute,
  } as any)
const MainExamsSlugAdminQuestionsIdEditRoute =
  MainExamsSlugAdminQuestionsIdEditRouteImport.update({
    id: '/exams/$slug/admin/questions/$id/edit',
    path: '/exams/$slug/admin/questions/$id/edit',
    getParentRoute: () => MainRoute,
  } as any)
const MainGroupsGidExamsSlugTestIdIndexRoute =
  MainGroupsGidExamsSlugTestIdIndexRouteImport.update({
    id: '/exams/$slug/test/$id/',
    path: '/exams/$slug/test/$id/',
    getParentRoute: () => MainGroupsGidRoute,
  } as any)
const MainGroupsGidExamsSlugTestIdResultRoute =
  MainGroupsGidExamsSlugTestIdResultRouteImport.update({
    id: '/exams/$slug/test/$id/result',
    path: '/exams/$slug/test/$id/result',
    getParentRoute: () => MainGroupsGidRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/admin': typeof MainAdminRoute
  '/dashboard': typeof MainDashboardRoute
  '/profile': typeof MainProfileRoute
  '/request-exam': typeof MainRequestExamRoute
  '/admin/groups': typeof MainAdminGroupsRoute
  '/groups/$gid': typeof MainGroupsGidRouteWithChildren
  '/exams/$slug/analytics': typeof MainExamsSlugAnalyticsRoute
  '/exams/$slug/history': typeof MainExamsSlugHistoryRoute
  '/exams/$slug/questions': typeof MainExamsSlugQuestionsRoute
  '/exams/$slug/submissions': typeof MainExamsSlugSubmissionsRoute
  '/exams/$slug/': typeof MainExamsSlugIndexRoute
  '/exams/$slug/admin/reports': typeof MainExamsSlugAdminReportsRoute
  '/exams/$slug/test/new': typeof MainExamsSlugTestNewRoute
  '/exams/$slug/admin/questions/bulk': typeof MainExamsSlugAdminQuestionsBulkRoute
  '/exams/$slug/admin/questions/generate': typeof MainExamsSlugAdminQuestionsGenerateRoute
  '/exams/$slug/admin/questions/new': typeof MainExamsSlugAdminQuestionsNewRoute
  '/exams/$slug/admin/questions/review': typeof MainExamsSlugAdminQuestionsReviewRoute
  '/exams/$slug/test/$id/result': typeof MainExamsSlugTestIdResultRoute
  '/groups/$gid/exams/$slug/analytics': typeof MainGroupsGidExamsSlugAnalyticsRoute
  '/groups/$gid/exams/$slug/history': typeof MainGroupsGidExamsSlugHistoryRoute
  '/groups/$gid/exams/$slug/questions': typeof MainGroupsGidExamsSlugQuestionsRoute
  '/exams/$slug/admin/questions/': typeof MainExamsSlugAdminQuestionsIndexRoute
  '/exams/$slug/test/$id/': typeof MainExamsSlugTestIdIndexRoute
  '/groups/$gid/exams/$slug/': typeof MainGroupsGidExamsSlugIndexRoute
  '/exams/$slug/admin/questions/$id/edit': typeof MainExamsSlugAdminQuestionsIdEditRoute
  '/groups/$gid/exams/$slug/test/new': typeof MainGroupsGidExamsSlugTestNewRoute
  '/groups/$gid/exams/$slug/test/$id/result': typeof MainGroupsGidExamsSlugTestIdResultRoute
  '/groups/$gid/exams/$slug/test/$id/': typeof MainGroupsGidExamsSlugTestIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/admin': typeof MainAdminRoute
  '/dashboard': typeof MainDashboardRoute
  '/profile': typeof MainProfileRoute
  '/request-exam': typeof MainRequestExamRoute
  '/admin/groups': typeof MainAdminGroupsRoute
  '/groups/$gid': typeof MainGroupsGidRouteWithChildren
  '/exams/$slug/analytics': typeof MainExamsSlugAnalyticsRoute
  '/exams/$slug/history': typeof MainExamsSlugHistoryRoute
  '/exams/$slug/questions': typeof MainExamsSlugQuestionsRoute
  '/exams/$slug/submissions': typeof MainExamsSlugSubmissionsRoute
  '/exams/$slug': typeof MainExamsSlugIndexRoute
  '/exams/$slug/admin/reports': typeof MainExamsSlugAdminReportsRoute
  '/exams/$slug/test/new': typeof MainExamsSlugTestNewRoute
  '/exams/$slug/admin/questions/bulk': typeof MainExamsSlugAdminQuestionsBulkRoute
  '/exams/$slug/admin/questions/generate': typeof MainExamsSlugAdminQuestionsGenerateRoute
  '/exams/$slug/admin/questions/new': typeof MainExamsSlugAdminQuestionsNewRoute
  '/exams/$slug/admin/questions/review': typeof MainExamsSlugAdminQuestionsReviewRoute
  '/exams/$slug/test/$id/result': typeof MainExamsSlugTestIdResultRoute
  '/groups/$gid/exams/$slug/analytics': typeof MainGroupsGidExamsSlugAnalyticsRoute
  '/groups/$gid/exams/$slug/history': typeof MainGroupsGidExamsSlugHistoryRoute
  '/groups/$gid/exams/$slug/questions': typeof MainGroupsGidExamsSlugQuestionsRoute
  '/exams/$slug/admin/questions': typeof MainExamsSlugAdminQuestionsIndexRoute
  '/exams/$slug/test/$id': typeof MainExamsSlugTestIdIndexRoute
  '/groups/$gid/exams/$slug': typeof MainGroupsGidExamsSlugIndexRoute
  '/exams/$slug/admin/questions/$id/edit': typeof MainExamsSlugAdminQuestionsIdEditRoute
  '/groups/$gid/exams/$slug/test/new': typeof MainGroupsGidExamsSlugTestNewRoute
  '/groups/$gid/exams/$slug/test/$id/result': typeof MainGroupsGidExamsSlugTestIdResultRoute
  '/groups/$gid/exams/$slug/test/$id': typeof MainGroupsGidExamsSlugTestIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_main': typeof MainRouteWithChildren
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/register': typeof AuthRegisterRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/verify-email': typeof AuthVerifyEmailRoute
  '/_main/admin': typeof MainAdminRoute
  '/_main/dashboard': typeof MainDashboardRoute
  '/_main/profile': typeof MainProfileRoute
  '/_main/request-exam': typeof MainRequestExamRoute
  '/_main/admin_/groups': typeof MainAdminGroupsRoute
  '/_main/groups/$gid': typeof MainGroupsGidRouteWithChildren
  '/_main/exams/$slug/analytics': typeof MainExamsSlugAnalyticsRoute
  '/_main/exams/$slug/history': typeof MainExamsSlugHistoryRoute
  '/_main/exams/$slug/questions': typeof MainExamsSlugQuestionsRoute
  '/_main/exams/$slug/submissions': typeof MainExamsSlugSubmissionsRoute
  '/_main/exams/$slug/': typeof MainExamsSlugIndexRoute
  '/_main/exams/$slug/admin/reports': typeof MainExamsSlugAdminReportsRoute
  '/_main/exams/$slug/test/new': typeof MainExamsSlugTestNewRoute
  '/_main/exams/$slug/admin/questions/bulk': typeof MainExamsSlugAdminQuestionsBulkRoute
  '/_main/exams/$slug/admin/questions/generate': typeof MainExamsSlugAdminQuestionsGenerateRoute
  '/_main/exams/$slug/admin/questions/new': typeof MainExamsSlugAdminQuestionsNewRoute
  '/_main/exams/$slug/admin/questions/review': typeof MainExamsSlugAdminQuestionsReviewRoute
  '/_main/exams/$slug/test/$id/result': typeof MainExamsSlugTestIdResultRoute
  '/_main/groups/$gid/exams/$slug/analytics': typeof MainGroupsGidExamsSlugAnalyticsRoute
  '/_main/groups/$gid/exams/$slug/history': typeof MainGroupsGidExamsSlugHistoryRoute
  '/_main/groups/$gid/exams/$slug/questions': typeof MainGroupsGidExamsSlugQuestionsRoute
  '/_main/exams/$slug/admin/questions/': typeof MainExamsSlugAdminQuestionsIndexRoute
  '/_main/exams/$slug/test/$id/': typeof MainExamsSlugTestIdIndexRoute
  '/_main/groups/$gid/exams/$slug/': typeof MainGroupsGidExamsSlugIndexRoute
  '/_main/exams/$slug/admin/questions/$id/edit': typeof MainExamsSlugAdminQuestionsIdEditRoute
  '/_main/groups/$gid/exams/$slug/test/new': typeof MainGroupsGidExamsSlugTestNewRoute
  '/_main/groups/$gid/exams/$slug/test/$id/result': typeof MainGroupsGidExamsSlugTestIdResultRoute
  '/_main/groups/$gid/exams/$slug/test/$id/': typeof MainGroupsGidExamsSlugTestIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/verify-email'
    | '/admin'
    | '/dashboard'
    | '/profile'
    | '/request-exam'
    | '/admin/groups'
    | '/groups/$gid'
    | '/exams/$slug/analytics'
    | '/exams/$slug/history'
    | '/exams/$slug/questions'
    | '/exams/$slug/submissions'
    | '/exams/$slug/'
    | '/exams/$slug/admin/reports'
    | '/exams/$slug/test/new'
    | '/exams/$slug/admin/questions/bulk'
    | '/exams/$slug/admin/questions/generate'
    | '/exams/$slug/admin/questions/new'
    | '/exams/$slug/admin/questions/review'
    | '/exams/$slug/test/$id/result'
    | '/groups/$gid/exams/$slug/analytics'
    | '/groups/$gid/exams/$slug/history'
    | '/groups/$gid/exams/$slug/questions'
    | '/exams/$slug/admin/questions/'
    | '/exams/$slug/test/$id/'
    | '/groups/$gid/exams/$slug/'
    | '/exams/$slug/admin/questions/$id/edit'
    | '/groups/$gid/exams/$slug/test/new'
    | '/groups/$gid/exams/$slug/test/$id/result'
    | '/groups/$gid/exams/$slug/test/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/verify-email'
    | '/admin'
    | '/dashboard'
    | '/profile'
    | '/request-exam'
    | '/admin/groups'
    | '/groups/$gid'
    | '/exams/$slug/analytics'
    | '/exams/$slug/history'
    | '/exams/$slug/questions'
    | '/exams/$slug/submissions'
    | '/exams/$slug'
    | '/exams/$slug/admin/reports'
    | '/exams/$slug/test/new'
    | '/exams/$slug/admin/questions/bulk'
    | '/exams/$slug/admin/questions/generate'
    | '/exams/$slug/admin/questions/new'
    | '/exams/$slug/admin/questions/review'
    | '/exams/$slug/test/$id/result'
    | '/groups/$gid/exams/$slug/analytics'
    | '/groups/$gid/exams/$slug/history'
    | '/groups/$gid/exams/$slug/questions'
    | '/exams/$slug/admin/questions'
    | '/exams/$slug/test/$id'
    | '/groups/$gid/exams/$slug'
    | '/exams/$slug/admin/questions/$id/edit'
    | '/groups/$gid/exams/$slug/test/new'
    | '/groups/$gid/exams/$slug/test/$id/result'
    | '/groups/$gid/exams/$slug/test/$id'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_main'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/register'
    | '/_auth/reset-password'
    | '/_auth/verify-email'
    | '/_main/admin'
    | '/_main/dashboard'
    | '/_main/profile'
    | '/_main/request-exam'
    | '/_main/admin_/groups'
    | '/_main/groups/$gid'
    | '/_main/exams/$slug/analytics'
    | '/_main/exams/$slug/history'
    | '/_main/exams/$slug/questions'
    | '/_main/exams/$slug/submissions'
    | '/_main/exams/$slug/'
    | '/_main/exams/$slug/admin/reports'
    | '/_main/exams/$slug/test/new'
    | '/_main/exams/$slug/admin/questions/bulk'
    | '/_main/exams/$slug/admin/questions/generate'
    | '/_main/exams/$slug/admin/questions/new'
    | '/_main/exams/$slug/admin/questions/review'
    | '/_main/exams/$slug/test/$id/result'
    | '/_main/groups/$gid/exams/$slug/analytics'
    | '/_main/groups/$gid/exams/$slug/history'
    | '/_main/groups/$gid/exams/$slug/questions'
    | '/_main/exams/$slug/admin/questions/'
    | '/_main/exams/$slug/test/$id/'
    | '/_main/groups/$gid/exams/$slug/'
    | '/_main/exams/$slug/admin/questions/$id/edit'
    | '/_main/groups/$gid/exams/$slug/test/new'
    | '/_main/groups/$gid/exams/$slug/test/$id/result'
    | '/_main/groups/$gid/exams/$slug/test/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  MainRoute: typeof MainRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_main': {
      id: '/_main'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof MainRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_main/request-exam': {
      id: '/_main/request-exam'
      path: '/request-exam'
      fullPath: '/request-exam'
      preLoaderRoute: typeof MainRequestExamRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/profile': {
      id: '/_main/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof MainProfileRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard': {
      id: '/_main/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof MainDashboardRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/admin': {
      id: '/_main/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof MainAdminRouteImport
      parentRoute: typeof MainRoute
    }
    '/_auth/verify-email': {
      id: '/_auth/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/register': {
      id: '/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_main/groups/$gid': {
      id: '/_main/groups/$gid'
      path: '/groups/$gid'
      fullPath: '/groups/$gid'
      preLoaderRoute: typeof MainGroupsGidRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/admin_/groups': {
      id: '/_main/admin_/groups'
      path: '/admin/groups'
      fullPath: '/admin/groups'
      preLoaderRoute: typeof MainAdminGroupsRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/exams/$slug/': {
      id: '/_main/exams/$slug/'
      path: '/exams/$slug'
      fullPath: '/exams/$slug/'
      preLoaderRoute: typeof MainExamsSlugIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/exams/$slug/submissions': {
      id: '/_main/exams/$slug/submissions'
      path: '/exams/$slug/submissions'
      fullPath: '/exams/$slug/submissions'
      preLoaderRoute: typeof MainExamsSlugSubmissionsRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/exams/$slug/questions': {
      id: '/_main/exams/$slug/questions'
      path: '/exams/$slug/questions'
      fullPath: '/exams/$slug/questions'
      preLoaderRoute: typeof MainExamsSlugQuestionsRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/exams/$slug/history': {
      id: '/_main/exams/$slug/history'
      path: '/exams/$slug/history'
      fullPath: '/exams/$slug/history'
      preLoaderRoute: typeof MainExamsSlugHistoryRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/exams/$slug/analytics': {
      id: '/_main/exams/$slug/analytics'
      path: '/exams/$slug/analytics'
      fullPath: '/exams/$slug/analytics'
      preLoaderRoute: typeof MainExamsSlugAnalyticsRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/exams/$slug/test/new': {
      id: '/_main/exams/$slug/test/new'
      path: '/exams/$slug/test/new'
      fullPath: '/exams/$slug/test/new'
      preLoaderRoute: typeof MainExamsSlugTestNewRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/exams/$slug/admin/reports': {
      id: '/_main/exams/$slug/admin/reports'
      path: '/exams/$slug/admin/reports'
      fullPath: '/exams/$slug/admin/reports'
      preLoaderRoute: typeof MainExamsSlugAdminReportsRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/groups/$gid/exams/$slug/': {
      id: '/_main/groups/$gid/exams/$slug/'
      path: '/exams/$slug'
      fullPath: '/groups/$gid/exams/$slug/'
      preLoaderRoute: typeof MainGroupsGidExamsSlugIndexRouteImport
      parentRoute: typeof MainGroupsGidRoute
    }
    '/_main/exams/$slug/test/$id/': {
      id: '/_main/exams/$slug/test/$id/'
      path: '/exams/$slug/test/$id'
      fullPath: '/exams/$slug/test/$id/'
      preLoaderRoute: typeof MainExamsSlugTestIdIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/exams/$slug/admin/questions/': {
      id: '/_main/exams/$slug/admin/questions/'
      path: '/exams/$slug/admin/questions'
      fullPath: '/exams/$slug/admin/questions/'
      preLoaderRoute: typeof MainExamsSlugAdminQuestionsIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/groups/$gid/exams/$slug/questions': {
      id: '/_main/groups/$gid/exams/$slug/questions'
      path: '/exams/$slug/questions'
      fullPath: '/groups/$gid/exams/$slug/questions'
      preLoaderRoute: typeof MainGroupsGidExamsSlugQuestionsRouteImport
      parentRoute: typeof MainGroupsGidRoute
    }
    '/_main/groups/$gid/exams/$slug/history': {
      id: '/_main/groups/$gid/exams/$slug/history'
      path: '/exams/$slug/history'
      fullPath: '/groups/$gid/exams/$slug/history'
      preLoaderRoute: typeof MainGroupsGidExamsSlugHistoryRouteImport
      parentRoute: typeof MainGroupsGidRoute
    }
    '/_main/groups/$gid/exams/$slug/analytics': {
      id: '/_main/groups/$gid/exams/$slug/analytics'
      path: '/exams/$slug/analytics'
      fullPath: '/groups/$gid/exams/$slug/analytics'
      preLoaderRoute: typeof MainGroupsGidExamsSlugAnalyticsRouteImport
      parentRoute: typeof MainGroupsGidRoute
    }
    '/_main/exams/$slug/test/$id/result': {
      id: '/_main/exams/$slug/test/$id/result'
      path: '/exams/$slug/test/$id/result'
      fullPath: '/exams/$slug/test/$id/result'
      preLoaderRoute: typeof MainExamsSlugTestIdResultRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/exams/$slug/admin/questions/review': {
      id: '/_main/exams/$slug/admin/questions/review'
      path: '/exams/$slug/admin/questions/review'
      fullPath: '/exams/$slug/admin/questions/review'
      preLoaderRoute: typeof MainExamsSlugAdminQuestionsReviewRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/exams/$slug/admin/questions/new': {
      id: '/_main/exams/$slug/admin/questions/new'
      path: '/exams/$slug/admin/questions/new'
      fullPath: '/exams/$slug/admin/questions/new'
      preLoaderRoute: typeof MainExamsSlugAdminQuestionsNewRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/exams/$slug/admin/questions/generate': {
      id: '/_main/exams/$slug/admin/questions/generate'
      path: '/exams/$slug/admin/questions/generate'
      fullPath: '/exams/$slug/admin/questions/generate'
      preLoaderRoute: typeof MainExamsSlugAdminQuestionsGenerateRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/exams/$slug/admin/questions/bulk': {
      id: '/_main/exams/$slug/admin/questions/bulk'
      path: '/exams/$slug/admin/questions/bulk'
      fullPath: '/exams/$slug/admin/questions/bulk'
      preLoaderRoute: typeof MainExamsSlugAdminQuestionsBulkRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/groups/$gid/exams/$slug/test/new': {
      id: '/_main/groups/$gid/exams/$slug/test/new'
      path: '/exams/$slug/test/new'
      fullPath: '/groups/$gid/exams/$slug/test/new'
      preLoaderRoute: typeof MainGroupsGidExamsSlugTestNewRouteImport
      parentRoute: typeof MainGroupsGidRoute
    }
    '/_main/exams/$slug/admin/questions/$id/edit': {
      id: '/_main/exams/$slug/admin/questions/$id/edit'
      path: '/exams/$slug/admin/questions/$id/edit'
      fullPath: '/exams/$slug/admin/questions/$id/edit'
      preLoaderRoute: typeof MainExamsSlugAdminQuestionsIdEditRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/groups/$gid/exams/$slug/test/$id/': {
      id: '/_main/groups/$gid/exams/$slug/test/$id/'
      path: '/exams/$slug/test/$id'
      fullPath: '/groups/$gid/exams/$slug/test/$id/'
      preLoaderRoute: typeof MainGroupsGidExamsSlugTestIdIndexRouteImport
      parentRoute: typeof MainGroupsGidRoute
    }
    '/_main/groups/$gid/exams/$slug/test/$id/result': {
      id: '/_main/groups/$gid/exams/$slug/test/$id/result'
      path: '/exams/$slug/test/$id/result'
      fullPath: '/groups/$gid/exams/$slug/test/$id/result'
      preLoaderRoute: typeof MainGroupsGidExamsSlugTestIdResultRouteImport
      parentRoute: typeof MainGroupsGidRoute
    }
  }
}

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface MainGroupsGidRouteChildren {
  MainGroupsGidExamsSlugAnalyticsRoute: typeof MainGroupsGidExamsSlugAnalyticsRoute
  MainGroupsGidExamsSlugHistoryRoute: typeof MainGroupsGidExamsSlugHistoryRoute
  MainGroupsGidExamsSlugQuestionsRoute: typeof MainGroupsGidExamsSlugQuestionsRoute
  MainGroupsGidExamsSlugIndexRoute: typeof MainGroupsGidExamsSlugIndexRoute
  MainGroupsGidExamsSlugTestNewRoute: typeof MainGroupsGidExamsSlugTestNewRoute
  MainGroupsGidExamsSlugTestIdResultRoute: typeof MainGroupsGidExamsSlugTestIdResultRoute
  MainGroupsGidExamsSlugTestIdIndexRoute: typeof MainGroupsGidExamsSlugTestIdIndexRoute
}

const MainGroupsGidRouteChildren: MainGroupsGidRouteChildren = {
  MainGroupsGidExamsSlugAnalyticsRoute: MainGroupsGidExamsSlugAnalyticsRoute,
  MainGroupsGidExamsSlugHistoryRoute: MainGroupsGidExamsSlugHistoryRoute,
  MainGroupsGidExamsSlugQuestionsRoute: MainGroupsGidExamsSlugQuestionsRoute,
  MainGroupsGidExamsSlugIndexRoute: MainGroupsGidExamsSlugIndexRoute,
  MainGroupsGidExamsSlugTestNewRoute: MainGroupsGidExamsSlugTestNewRoute,
  MainGroupsGidExamsSlugTestIdResultRoute:
    MainGroupsGidExamsSlugTestIdResultRoute,
  MainGroupsGidExamsSlugTestIdIndexRoute:
    MainGroupsGidExamsSlugTestIdIndexRoute,
}

const MainGroupsGidRouteWithChildren = MainGroupsGidRoute._addFileChildren(
  MainGroupsGidRouteChildren,
)

interface MainRouteChildren {
  MainAdminRoute: typeof MainAdminRoute
  MainDashboardRoute: typeof MainDashboardRoute
  MainProfileRoute: typeof MainProfileRoute
  MainRequestExamRoute: typeof MainRequestExamRoute
  MainAdminGroupsRoute: typeof MainAdminGroupsRoute
  MainGroupsGidRoute: typeof MainGroupsGidRouteWithChildren
  MainExamsSlugAnalyticsRoute: typeof MainExamsSlugAnalyticsRoute
  MainExamsSlugHistoryRoute: typeof MainExamsSlugHistoryRoute
  MainExamsSlugQuestionsRoute: typeof MainExamsSlugQuestionsRoute
  MainExamsSlugSubmissionsRoute: typeof MainExamsSlugSubmissionsRoute
  MainExamsSlugIndexRoute: typeof MainExamsSlugIndexRoute
  MainExamsSlugAdminReportsRoute: typeof MainExamsSlugAdminReportsRoute
  MainExamsSlugTestNewRoute: typeof MainExamsSlugTestNewRoute
  MainExamsSlugAdminQuestionsBulkRoute: typeof MainExamsSlugAdminQuestionsBulkRoute
  MainExamsSlugAdminQuestionsGenerateRoute: typeof MainExamsSlugAdminQuestionsGenerateRoute
  MainExamsSlugAdminQuestionsNewRoute: typeof MainExamsSlugAdminQuestionsNewRoute
  MainExamsSlugAdminQuestionsReviewRoute: typeof MainExamsSlugAdminQuestionsReviewRoute
  MainExamsSlugTestIdResultRoute: typeof MainExamsSlugTestIdResultRoute
  MainExamsSlugAdminQuestionsIndexRoute: typeof MainExamsSlugAdminQuestionsIndexRoute
  MainExamsSlugTestIdIndexRoute: typeof MainExamsSlugTestIdIndexRoute
  MainExamsSlugAdminQuestionsIdEditRoute: typeof MainExamsSlugAdminQuestionsIdEditRoute
}

const MainRouteChildren: MainRouteChildren = {
  MainAdminRoute: MainAdminRoute,
  MainDashboardRoute: MainDashboardRoute,
  MainProfileRoute: MainProfileRoute,
  MainRequestExamRoute: MainRequestExamRoute,
  MainAdminGroupsRoute: MainAdminGroupsRoute,
  MainGroupsGidRoute: MainGroupsGidRouteWithChildren,
  MainExamsSlugAnalyticsRoute: MainExamsSlugAnalyticsRoute,
  MainExamsSlugHistoryRoute: MainExamsSlugHistoryRoute,
  MainExamsSlugQuestionsRoute: MainExamsSlugQuestionsRoute,
  MainExamsSlugSubmissionsRoute: MainExamsSlugSubmissionsRoute,
  MainExamsSlugIndexRoute: MainExamsSlugIndexRoute,
  MainExamsSlugAdminReportsRoute: MainExamsSlugAdminReportsRoute,
  MainExamsSlugTestNewRoute: MainExamsSlugTestNewRoute,
  MainExamsSlugAdminQuestionsBulkRoute: MainExamsSlugAdminQuestionsBulkRoute,
  MainExamsSlugAdminQuestionsGenerateRoute:
    MainExamsSlugAdminQuestionsGenerateRoute,
  MainExamsSlugAdminQuestionsNewRoute: MainExamsSlugAdminQuestionsNewRoute,
  MainExamsSlugAdminQuestionsReviewRoute:
    MainExamsSlugAdminQuestionsReviewRoute,
  MainExamsSlugTestIdResultRoute: MainExamsSlugTestIdResultRoute,
  MainExamsSlugAdminQuestionsIndexRoute: MainExamsSlugAdminQuestionsIndexRoute,
  MainExamsSlugTestIdIndexRoute: MainExamsSlugTestIdIndexRoute,
  MainExamsSlugAdminQuestionsIdEditRoute:
    MainExamsSlugAdminQuestionsIdEditRoute,
}

const MainRouteWithChildren = MainRoute._addFileChildren(MainRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  MainRoute: MainRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
